<template>
  <section class="distributionSection">
    <InfographicSection
      :button-class-name="'btn-round-white'"
      :button-text="'Read more'"
      :has-inverted-layout="true"
      :has-main-heading-title="true"
      :has-white-text="true"
      :on-button-click="
        () => router.push({ name: 'GhostPage', params: { slug: 'how-to-distribute-your-rss-feed-to-other-platforms' } })
      "
      :paragraph="'Expand and grow your audience by distributing to the top podcasting apps and directories in the world.'"
      :title="'Distribution'"
    >
      <img alt="Afripods distribution" class="infographicImage" src="static/images/home/distribution.svg" />
    </InfographicSection>
  </section>
</template>

<script setup>
import { useRouter } from 'vue-router/composables'

import InfographicSection from 'components/reused-components/infographicSection/InfographicSection'

const router = useRouter()
</script>

<style lang="scss" scoped>
@import 'assets/scss/base/bootstrap_variables';
@import 'assets/scss/base/functions';

.distributionSection {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1200px;
  padding: 0 16px;
  margin: 88px auto;

  @media (min-width: $screen-sm-min) {
    padding: 0 32px;
  }

  .infographicImage {
    width: 100%;
    max-width: 460px;
    margin: 0 auto;

    @media (min-width: $screen-sm-min) {
      max-width: 80%;
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// DistributionSection.vue